function getId(obj) {
  if (obj) {
    return obj.id;
  }
}

const infoEndosso = () => ({
  idTipoDeProposta: null,
  apoliceNumero: null,
  codigoEndosso: null,
  apoliceNumeroProposta: null,
  dataUltimaAtualizacao: null,
  idTipoEndosso: null,
  dateInicio: null,
  dateFim: null,
  naoCalcularItens: null,
  diasVigencia: null,
  idMotivoEndosso: null,
  textoLivreEndosso: null,
  apoliceEndereco: null,
  premioTotalEndosso: null,
  valorRestituicao: null,
  participantes: [],
  dataInicio: null,
  idParcelamento: null,
  idFormaPagamento: null,
  apoliceIof: null,
  corretagem: null,
  dataPrimeiraParcela: null,
  idRascunhoEndosso: null,
  itemRemovidoList: [],
  uuidRevisao: null,
  percCondicaoComercial: null,
  aplicaCondicao: null,
  idAplicaCondicao: null,
  idTipoCondicao: null,
  idStatusEndosso: null,
  proponenteRazaoSocial: null,
  idTipoPessoa: null,
  proponenteCnpj: null,
  recalcular: null,
  idTecnicoResponsavelEndosso: null,
  nomeTecnicoResponsavelEndosso: null,
  idCorretorResponsavelEndosso: null,
  nomeCorretorResponsavelEndosso: null,
  idEndossoRascunhoSalvo: null,
  nomeCorretorParceiro: null,
  numeroReserva: null,
  tipoEndossoSolicitado: null,
  listaCondicaoComercialEspecial: [],
  listaCondicaoComercialEspecialModificacao: [],
});

const totaisEndosso = () => ({
  totalAp: null,
  totalCoberturaCompensativa: null,
  totalCoberturaRcf: null,
  totalCoberturasAdicionais: null,
  totalFranquiaCoberturaAcessorios: null,
  totalFranquiaCoberturaCarroceria: null,
  totalFranquiaCoberturaCompensativa: null,
  totalFranquiaCoberturaEquipamentos: null,
  totalPremio: null,
  totalPremioLiquido: null,
  totalRestituicao: null,
  totalServicosAgregados: null
});
const inicial = () => ({
  // planilha importada
  conteudoPlanilha: [],
  erroPlanilha: [],
  id: null,
  versao: null,
  apoliceNumeroProposta: null,
  apoliceNumero: null,
  itemAdicionadoList: [],
  itemRemovidoList: [],
  itemModificadoList: [],
  itensRestantes: [],

  ...infoEndosso(),
  ...totaisEndosso()
});
const state = {
  ...inicial()
};
const mutations = {
  dadosItensRestantes(state, { dados }) {
    state.itensRestantes = dados;
  },
  dadosItemExclusao(state, { dados }) {
    state.itemRemovidoList = dados;
  },
  setConteudoPlanilha(state, { dados }) {
    if (dados instanceof Array) {
      state.conteudoPlanilha = dados;
    }
  },
  setItensAdicionados(state, { dados }) {
    if (dados instanceof Array) {
      state.itemAdicionadoList = dados;
    }
  },

  setItensModificados(state, { dados }) {
    if (dados instanceof Array) {
      state.itemModificadoList = dados;
    }
  },

  setErroPlanilha(state, { dados }) {
    if (dados instanceof Array) {
      state.erroPlanilha = dados;
    }
  },
  setInfoEndosso(state, objetoInfoEndosso) {
    if (objetoInfoEndosso.totaisEndosso) {
      Object.keys(totaisEndosso()).forEach(key => {
        state[key] = objetoInfoEndosso.totaisEndosso[key];
      });
    }
    if (objetoInfoEndosso.itemModificadoList instanceof Array) {
      state.itemModificadoList = objetoInfoEndosso.itemModificadoList;
    }
    if (objetoInfoEndosso.itemAdicionadoList instanceof Array) {
      state.itemAdicionadoList = objetoInfoEndosso.itemAdicionadoList;
    }
    if (objetoInfoEndosso.itemRemovidoList instanceof Array) {
      state.itemRemovidoList = objetoInfoEndosso.itemRemovidoList;
    }

    Object.keys(infoEndosso()).forEach(key => {
      state[key] = objetoInfoEndosso[key];
      if (objetoInfoEndosso.itemAdicionadoList) {
        state.conteudoPlanilha = objetoInfoEndosso.itemAdicionadoList;
      } else {
        objetoInfoEndosso.conteudoPlanilha = state.conteudoPlanilha;
      }
    });
  },

  setDadosPagamento(state, dados) {
    state.dataPrimeiraParcela = dados.dataPrimeiraParcela;
    state.idParcelamento = dados.idParcelamento;
    state.idFormaPagamento = dados.idFormaPagamento;
    state.apoliceIof = dados.apoliceIof;
    state.corretagem = dados.corretagem;
  },

  setCondicaoComercial(state, condicao) {
    state.idTipoCondicao = condicao.idTipoCondicao;
    state.idAplicaCondicao = condicao.idAplicaCondicao;
    state.percCondicaoComercial = condicao.percCondicaoComercial;
    state.listaCondicaoComercialEspecial = condicao.listaCondicaoComercialEspecial;
    state.listaCondicaoComercialEspecialModificacao = condicao.listaCondicaoComercialEspecialModificacao;
  },
  limparTudo(state) {
    Object.entries(inicial()).forEach(([key, value]) => {
      state[key] = value;
    });
  }
};

const getters = {
  recalcular(state) {
    return state;
  },
  conteudoPlanilhaValido(state) {
    return (
      state.conteudoPlanilha instanceof Array && !!state.conteudoPlanilha.length
    );
  },
  quantidadeItem(state) {
    return state.conteudoPlanilha.length;
  },
  totais(state) {
    return Object.fromEntries(
      Object.keys(totaisEndosso()).map(key => [key, state[key]])
    );
  },
  conteudoSalvarEndosso(state) {
    const { erroPlanilha, ...endosso } = state;
    return endosso;
  },
  conteudoInfoEndossoValido(state, getters) {
    return (
      getters.conteudoPlanilhaValido &&
      Object.keys(infoEndosso()).every(
        key => state[key] !== null && state[key] !== undefined
      )
    );
  },
  cloneConteudoPlanilha(state) {
    try {
      return JSON.parse(JSON.stringify(state.conteudoPlanilha));
    } catch (error) {
      return [];
    }
  },
  cloneItemAdicionadoList(state) {
    try {
      return JSON.parse(JSON.stringify(state.itemAdicionadoList));
    } catch (error) {
      return [];
    }
  },

  requisicaoEndossoAdicionar(state) {
    try {
      return JSON.parse(
        JSON.stringify({
          itemAdicionadoList: state.itemAdicionadoList,
          itemModificadoList: [],
          idTipoEndosso: state.idTipoEndosso,
          dateInicio: state.dateInicio,
          dataPrimeiraParcela: state.dataPrimeiraParcela,
          idParcelamento: state.idParcelamento,
          percCondicaoComercial: state.percCondicaoComercial,
          idAplicaCondicao: state.idAplicaCondicao,
          idEndossoRascunhoSalvo: state.idEndossoRascunhoSalvo,
          proponenteRazaoSocial: state.proponenteRazaoSocial,
          idTipoPessoa: state.idTipoPessoa,
          proponenteCnpj: state.proponenteCnpj,
          textoLivreEndosso: state.textoLivreEndosso,
          idMotivoEndosso: state.idMotivoEndosso,
          idFormaPagamento: state.idFormaPagamento,
          listaCondicaoComercialEspecial: state.listaCondicaoComercialEspecial,
          listaCondicaoComercialEspecialModificacao: state.listaCondicaoComercialEspecialModificacao
        })
      );
    } catch (error) {
      return [];
    }
  },

  requisicaoEndossoModificar(state) {
    try {
      return JSON.parse(
        JSON.stringify({
          itemModificadoList: state.itemModificadoList,
          idTipoEndosso: state.idTipoEndosso,
          dateInicio: state.dateInicio,
          dataPrimeiraParcela: state.dataPrimeiraParcela,
          idParcelamento: state.idParcelamento,
          naoCalcularItens: state.naoCalcularItens,
          percCondicaoComercial: state.percCondicaoComercial,
          idAplicaCondicao: state.idAplicaCondicao
        })
      );
    } catch (error) {
      return [];
    }
  },

  cloneErroPlanilha(state) {
    try {
      return JSON.parse(JSON.stringify(state.erroPlanilha));
    } catch (error) {
      return [];
    }
  },
  infoEndosso(state) {
    return {
      ...Object.fromEntries(
        Object.keys(infoEndosso()).map(key => [key, state[key]])
      ),
      recalcular: state.recalcular,
      totalPremio: state.totalPremio,
      totalRestituicao: state.totalRestituicao,
      apoliceNumero: state.apoliceNumero,
      apoliceNumeroProposta: state.apoliceNumeroProposta,
      itemRemovidoList: state.itemRemovidoList
    };
  },
  dadosEndosso(state) {
    return {
      idMotivoEndosso: state.idMotivoEndosso,
      textoLivreEndosso: state.textoLivreEndosso,
      dateInicio: state.dateInicio,
      idTipoEndosso: state.idTipoEndosso,
      idApolice: state.idApolice,
      idParcelamento: state.idParcelamento,
      idFormaPagamento: state.idFormaPagamento,
      apoliceIof: state.apoliceIof,
      corretagem: state.corretagem,
      dataPrimeiraParcela: state.dataPrimeiraParcela,
      percCondicaoComercial: state.percCondicaoComercial,
      idAplicaCondicao: state.idAplicaCondicao,
      idTipoCondicao: state.idTipoCondicao,
      idEndossoRascunhoSalvo: state.idEndossoRascunhoSalvo,
      proponenteRazaoSocial: state.proponenteRazaoSocial,
      idTipoPessoa: state.idTipoPessoa,
      proponenteCnpj: state.proponenteCnpj
    };
  },
  dadosItemExclusao(state) {
    return {
      itemRemovidoList: state.itemRemovidoList
    };
  },
  setItensModificados(state) {
    return {
      itemModificadoList: state.itemModificadoList
    };
  },
  dadosItensRestantes(state) {
    return {
      itensRestantes: state.itensRestantes
    };
  }
};
export default {
  namespaced: true,
  state,
  mutations,
  getters
};



// WEBPACK FOOTER //
// ./src/store/modules/formEndosso.js